
<ng-container *ngIf="isAdvProgram">
  <mat-spinner *ngIf="creatingApplication" class="td-advising-spinner"></mat-spinner>
  <ng-container *ngIf="!creatingApplication && creatAppErroMsg">
    <h3 class="creat-app-error-msg">{{ creatAppErroMsg }}</h3>
  </ng-container>
</ng-container>

<ng-container *ngIf="( ((existingApplications || requiresItinerary || publicAppCycle) && !isAdvProgram) || (existingApplications && isAdvProgram))">
  <h2 *ngIf="!isISSS">Program Options</h2>
  <h2 *ngIf="isISSS">Available Terms</h2>
  <div class="td-login-assist-text">
    <p [innerHTML]="i18nFields.selectProgramOption | safe: 'html'"></p>
  </div>
  <ng-container *ngIf="existingApplications">
    <div class="alert alert-warning td-existing-apps-alert">
      <span [innerHTML]="i18nFields.existingApplications | safe: 'html'"></span>
      <mat-list role="list" class="td-existing-apps-list">
        <mat-list-item role="listitem" *ngFor="let eA of this.activeAppCycleResults.existingApplicationData" class="td-existing-apps-list-item">
          <ng-container *ngIf="angularApplicationUI">
            <a href="{{'/index.cfm?FuseAction=Students.AngularApplication&applicationId=' + eA.applicationId}}" > 
              <span>
                {{ eA.term }} {{ eA.year }}
              </span>
              <fa-icon icon="chevron-circle-right"  class="td-table-icons"></fa-icon>
            </a>
          </ng-container>
          <ng-container *ngIf="!angularApplicationUI">
            <a href="{{'/index.cfm?FuseAction=Students.Application&Application_ID=' + eA.applicationId}}" > 
              <span>
                {{ eA.term }} {{ eA.year }}
              </span>
              <fa-icon icon="chevron-circle-right"  class="td-table-icons"></fa-icon>
            </a>
          </ng-container>
        </mat-list-item>
      </mat-list>
    </div>
  </ng-container>

  <div class="td-form-row" *ngIf="publicAppCycle && userCreateApplication">
    <form [formGroup]="programAppCycleForm" class="td-full-form">
      <mat-form-field class="td-full-form">
        <mat-label>Select Term</mat-label>
        <mat-select formControlName="tdAppCycle" required (selectionChange)="onChangeTerm($event)">
          <mat-option *ngFor="let t of activeAppCycleResults.appCycleInfo" [value]="t">
            {{t.term}} {{ t.year }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</ng-container> 

<div class="td-form-row" *ngIf="requiresItinerary && !isAdvProgram && userCreateApplication">
  <!-- *ngIf="requiresItinerary && !isAdvProgram && userCreateApplication" -->
  <div class="alert alert-warning td-itinerary-alert" *ngIf="showItineraryAlert">
    <span>You must add at least one itinerary in order to submit this form.</span>
  </div>
  
  <!-- <table class="table table-sm table-hover td-table-baseline-align td-itinerary-table"> -->
      <!-- <thead class="td-itinerary-header">
        <tr>
          <th class="td-itinerary-table-location">Location</th>
          <th class="td-start-date td-itinerary-table-date">{{ i18nFields.itineraryStartDate }}</th>
          <th class="td-end-date td-itinerary-table-date">{{ i18nFields.itineraryEndDate }}</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>-->
        <!-- <ng-container *ngFor="let itinerary of applicationItineraries">
          <tr *ngIf="!itineraryState.get(itinerary).isEditing" class="td-itinerary-body">
            <td class="td-itinerary-table-location">
              <span class="td-label-text">Location</span>
              {{ itinerary.displayLocation }}
            </td>
            <td class="td-start-date td-itinerary-table-date">
              <span class="td-label-text">{{ i18nFields.itineraryStartDate }}</span>
              <span>{{ itinerary.startDate | tddate }}</span>
            </td>
            <td class="td-end-date td-itinerary-table-date">
              <span class="td-label-text">{{ i18nFields.itineraryEndDate }}</span>
              <span>{{ itinerary.endDate | tddate }}</span>
            </td>
            <td class="td-table-actions">
              <button mat-icon-button (click)="onEdit(itinerary)" *ngIf="showEditItineraryButton" class="td-action-button" [style.color]="primaryColor">
                <fa-icon icon="pencil-alt"></fa-icon>
              </button>
              <button mat-icon-button (click)="onDelete(itinerary)" *ngIf="showDeleteItineraryButton" class="td-action-button td-action-delete">
                <fa-icon icon="trash-alt"></fa-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="itineraryState.get(itinerary).isEditing" [formGroup]="updateForm">
            <td class="td-itinerary-table-location">
              <span class="td-label-text">Location</span>
              <mat-form-field class="form-field" style="width:100%;">
                <input formControlName="locationInput"
                  [matAutocomplete]="autoUpdateLocations"
                  matInput #locationUpdateInput>
                  <mat-autocomplete #autoUpdateLocations="matAutocomplete" (optionSelected)="updateSelectedLocation($event)"
                    [displayWith]="updateLocationDisplayFn">
                    <mat-option *ngFor="let option of updateLocations" [value]="option">
                      {{ option.displayLocation }}
                    </mat-option>
                    <mat-option *ngFor="let option of googleLocations" [value]="option">
                      {{ option.formatted_address }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-label>
                    <fa-icon icon="globe"></fa-icon>
                    Add location to Itinerary
                  </mat-label>
                  <mat-spinner matSuffix
                    *ngIf="loadingUpdateLocation"
                    diameter="18"></mat-spinner>
              </mat-form-field>
            </td>
            <td class="td-itinerary-table-date">
              <span class="td-label-text">{{ i18nFields.itineraryStartDate }}</span>
              <mat-form-field class="form-field td-start-date">
                <input matInput #editStartInput
                  [matDatepicker]="editStartDatepicker" 
                  placeholder="{{ i18nFields.itineraryStartDate }}"
                  formControlName="startDate"
                  [max]="updateForm.get('endDate').value"
                  (focus)="editStartDatepicker.open()">
                <mat-datepicker-toggle matSuffix [for]="editStartDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #editStartDatepicker
                  [tdsFocusAfterOpened]="editStartInput"></mat-datepicker>
              </mat-form-field>
            </td>
            <td class="td-itinerary-table-date">
              <span class="td-label-text">{{ i18nFields.itineraryEndDate }}</span>
              <mat-form-field class="form-field td-end-date">
                <input matInput #editEndInput
                  [matDatepicker]="editEndDatepicker" 
                  placeholder="{{ i18nFields.itineraryEndDate }}"
                  formControlName="endDate"
                  [min]="updateForm.get('startDate').value"
                  (focus)="editEndDatepicker.open()">
                <mat-datepicker-toggle matSuffix [for]="editEndDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #editEndDatepicker
                  [tdsFocusAfterOpened]="editEndInput"></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <button mat-icon-button (click)="onSubmitItinerary(itinerary)">
                <mat-icon>check</mat-icon>
              </button>
            </td>
          </tr>
        </ng-container> -->
        <!-- <ng-container *ngIf="showAddItineraryForm">
          <tr [formGroup]="itineraryForm" (ngSubmit)="onSubmit(itineraryForm.value)">

            <td class="td-itinerary-table-location">
              <span class="td-label-text">Location</span>
              <mat-form-field class="form-field" style="width:100%;">
                <input formControlName="locationInput"
                  [matAutocomplete]="autoLocations"
                  matInput #locationInput>
                  <mat-autocomplete #autoLocations="matAutocomplete" (optionSelected)="selectedLocation($event)" 
                    [displayWith]="locationDisplayFn">
                    <mat-option *ngFor="let option of locations" [value]="option">
                      {{ option.CITY }}, {{ option.COUNTRY}} ({{option.REGION}})
                    </mat-option>
                    <mat-option *ngFor="let option of googleLocations" [value]="option">
                      {{ option.formatted_address }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-label>
                    <fa-icon icon="globe"></fa-icon>
                    Add location to Itinerary
                  </mat-label>
                  <mat-spinner matSuffix
                    *ngIf="loadingLocation"
                    diameter="18"></mat-spinner>
              </mat-form-field>
            </td>
            <td class="td-itinerary-table-date"> 
              <span class="td-label-text">{{ i18nFields.itineraryStartDate }}</span>
              <mat-form-field class="form-field td-start-date">
                <input matInput #startInput
                  [matDatepicker]="startDatepicker" 
                  placeholder="{{ i18nFields.itineraryStartDate }}"
                  formControlName="startDate"
                  [max]="itineraryForm.get('endDate').value"
                  (focus)="startDatepicker.open()">
                <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatepicker
                  [tdsFocusAfterOpened]="startInput"></mat-datepicker>
              </mat-form-field>
            </td>
            <td class="td-itinerary-table-date"> 
              <span class="td-label-text">{{ i18nFields.itineraryEndDate }}</span>
              <mat-form-field class="form-field td-end-date">
                <input matInput #endInput
                  [matDatepicker]="endDatepicker" 
                  placeholder="{{ i18nFields.itineraryEndDate }}"
                  formControlName="endDate"
                  [min]="itineraryForm.get('startDate').value"
                  (focus)="endDatepicker.open()">
                <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatepicker
                  [tdsFocusAfterOpened]="endInput"></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <button mat-mini-fab
                [disabled]="itineraryForm.invalid"
                (click)="onSubmit(itineraryForm.value)"
                color="primary" class="add-button"
                matTooltip="Add itinerary."
                matTooltipClass="td-tooltip">
                <mat-icon>add</mat-icon>
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <span class="td-no-matching-locations-exist" *ngIf="noMatchingLocations">Location doesn't exist on site. Please try another location.</span>
            </td>
          </tr>
        </ng-container> -->
      <!-- </tbody> -->
  <!-- </table> -->

  <div class="itinerary-form-container">
    <form class="basic-container" [formGroup]="testForm">
      <div formArrayName="groups">
        <div class="row" *ngFor="let group of testForm.get('groups').controls; let i = index" [formGroupName] = "i">
          
          <mat-form-field class="col-xs-4">
            <input class="pl-3" formControlName="locationInput" [matAutocomplete]="autoLocations" matInput #locationInput (change)="onFocusOutEvent($event, i)">
              <mat-autocomplete #autoLocations="matAutocomplete" (optionSelected)="selectedLocation(i, group, $event)" [displayWith]="locationDisplayFn">
                <mat-option *ngFor="let option of locations" [value]="option">
                  {{ option.CITY }}, {{ option.COUNTRY}} ({{option.REGION}})
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="group.controls['locationInput'].getError('invalid') == true">
                  Please select a Location
              </mat-error>
              <mat-label class="pl-3">
                Add Location to Itinerary
              </mat-label>
              <span matPrefix>
                <fa-icon class="td-icon-color" icon="globe"></fa-icon>
              </span>
              <mat-spinner matSuffix *ngIf="loadingLocationArray[i]" diameter="18"></mat-spinner>
          </mat-form-field>
  
          <mat-form-field class="col-xs-3">
            <mat-label>Arrival Date</mat-label>
              <input matInput #startInput [matDatepicker]="startDatepicker" formControlName="startDate"
                (focus)="startDatepicker.open()">
              <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatepicker [tdsFocusAfterOpened]="startInput"></mat-datepicker>
          </mat-form-field>
  
          <mat-form-field class="col-xs-3">
            <mat-label>Departure Date</mat-label>
            <input matInput #endInput [matDatepicker]="endDatepicker" formControlName="endDate"
              [min]="group.get('startDate').value"
              (focus)="endDatepicker.open()">
            <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatepicker [tdsFocusAfterOpened]="endInput"></mat-datepicker>
          </mat-form-field>
  
          <div class="col-xs-1 col-rm">
            <button mat-icon-button *ngIf="i >= 0" class="td-action-button td-action-delete" (click)="onDeleteItinerary(i)" 
              matTooltip="Remove" matTooltipClass="td-tooltip" matTooltipPosition="above">
              <fa-icon icon="trash-alt"></fa-icon>
            </button>
          </div>
  
        </div>
      </div>
      <div class="btn-add-itinerary-cont">
        <button mat-mini-fab (click)="addFormGroup()" color="primary" class="add-button" matTooltip="Add itinerary" matTooltipClass="td-tooltip" matTooltipPosition="above">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </form>
  </div>
  <!-- <button mat-flat-button color="primary" (click)="populateItineraryData(tempralApplicationItineraries)">Continue</button>
  <button mat-flat-button color="primary" (click)="resetForm()">Reset Form</button> -->
</div>

<div class="td-form-row" *ngIf="requiresAdvising">
  <p class="td-advising-msg-text">{{ advisingMsg }}</p>
</div> 

<div class="td-action-button-row" *ngIf="!isAdvProgram">
  
  <ng-container class="creat-app" *ngIf="creatingApplication && !(requiresItinerary || publicAppCycle || requiresAdvising)">
    <h3>Creating Application</h3>
    <mat-spinner class="creat-app-spinner" diameter="24" color="primary"></mat-spinner>
  </ng-container>

  <ng-container *ngIf="!creatingApplication && creatAppErroMsg">
    <h3 class="creat-app-error-msg">{{ creatAppErroMsg }}</h3>
  </ng-container>

  <ng-container *ngIf="!userCreateApplication && reasonForDenyingApplication != '' ">
    <h3 class="creat-app-error-msg">{{ reasonForDenyingApplication }}</h3>
  </ng-container>
  
  <div class="td-create-application-buttons" *ngIf="((requiresItinerary && userCreateApplication) || (publicAppCycle && userCreateApplication) || requiresAdvising)">
    <!-- *ngIf="(requiresItinerary || (publicAppCycle && userCreateApplication) || requiresAdvising)" -->
    <button mat-flat-button 
      class="td-form-apply-button" 
      type="submit" 
      [style.background-color]="primaryColor"          
      (click)="cancelApplication()">Cancel</button>
    <button mat-flat-button *ngIf="advisingApplicationExists && activeAppCycleResults.userCanCreateAdvisingApplication"
      class="td-form-apply-button td-continue-btn" 
      type="submit" 
      [disabled]="disabledContinueBtn"
      [style.background-color]="(disabledContinueBtn) ? null : primaryColor"
      (click)="addProgramOfInterest()">
      <!-- [disabled]="creatingApplication || (publicAppCycle && programAppCycleForm.invalid) || (requiresItinerary && (applicationItineraries && applicationItineraries.length === 0))"
      [style.background-color]="creatingApplication || (publicAppCycle && programAppCycleForm.invalid) || (requiresItinerary && (applicationItineraries && applicationItineraries.length === 0)) ? null : primaryColor" -->
        <mat-spinner *ngIf="creatingApplication" diameter="24" color="primary"></mat-spinner>
        <span *ngIf="!creatingApplication">Go to Advising Application</span>
    </button> 
    <button mat-flat-button *ngIf="!advisingApplicationExists"
      class="td-form-apply-button td-continue-btn" 
      type="submit" 
      [disabled]="disabledContinueBtn"
      [style.background-color]="(disabledContinueBtn) ? null : primaryColor"
      (click)="createApplication()">
      <!-- [disabled]="creatingApplication || (publicAppCycle && programAppCycleForm.invalid) || (requiresItinerary && testForm.invalid && applicationItineraries.length === 0)" -->
      <!-- [style.background-color]="creatingApplication || ( (publicAppCycle && programAppCycleForm.invalid)) || (requiresItinerary && (applicationItineraries && applicationItineraries.length === 0)) ? null : primaryColor" -->
        <mat-spinner *ngIf="creatingApplication" diameter="24" color="primary"></mat-spinner>
        <span *ngIf="!creatingApplication">Continue</span>
    </button>
  </div>
</div>

<div #googleAttributions></div>

<ng-template #removeItineraryDialog let-data let-dialogRef="dialogRef">
  <mat-toolbar class="td-dialog-header bg-primary">
    <h4>Confirmation</h4>
  </mat-toolbar>
  <mat-dialog-content>
    <p class="td-text">Do you really want to remove this itinerary entry?</p>
  </mat-dialog-content>
  <mat-dialog-actions>
      <span class="td-fill-remaining"></span>
      <button mat-raised-button color="primary" (click)="dialogRef.close(false)">Cancel</button>
      <button mat-raised-button color="warn" (click)="dialogRef.close(true)">Remove</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #redirectProgramDiscoveryDialog let-data let-dialogRef="dialogRef">
  <mat-toolbar class="td-dialog-header bg-primary">
    <h4>Information</h4>
  </mat-toolbar>
  <mat-dialog-content>
    <p class="td-text">{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
      <span class="td-fill-remaining"></span>
      <button mat-raised-button color="primary" (click)="dialogRef.close(false)">Ok</button>
  </mat-dialog-actions>
</ng-template>